// extracted by mini-css-extract-plugin
export default {"BackToOverviewButton":"BackToOverviewButton_BackToOverviewButton__9Pg4k","button_text":"BackToOverviewButton_button_text__zrNp5","icon":"BackToOverviewButton_icon__ws-cH"};